import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { catchError, switchMap, concatMap, map } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { NetworkCallService } from '../../../core/services/network-call.service';
import * as forgotPasscodeVerify from '../actions/forgot-passcode-verify.actions';
import * as actions from '../actions';
import { IForgotPasscodeVerifyRequest, IForgotPasscodeVerifyResponse, IVerifyOTPRequest, IVerifyOTPResponse } from '../models/forgot-passcode-verify.model';
import { HelpersService } from '../../../core/services/helpers.service';
import notify from 'devextreme/ui/notify';
import { RouteURL, SessionStorageIds } from '../../../shared/enums';
import { IBusinessUserRolesRequest } from '../models/business-user-roles.model';
import { Store } from '@ngrx/store';
import { EMPTY_GUID } from '../../../shared/constants';

@Injectable()
export class ForgotPasscodeVerifyEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService,
    private store: Store
  ) {}

  forgotPasscodeVerify$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasscodeVerify.loadForgotPasscodeVerify),
      switchMap(action =>
        this.networkCallService
          .post<IForgotPasscodeVerifyRequest, IForgotPasscodeVerifyResponse>('Authentication/forgotPasscodeVerify', action.request)
          .pipe(
            map(response => {
              if (response.success && !response.invalidMobileNumber && !response.locked) {
                this.router.navigateByUrl('auth/forgot-passcode-otp');
              } else if (!response.success && !response.invalidMobileNumber && !response.locked) {
                this.helperService.notifyError('Please check you details and try again', 300, 3000);
              } else if (!response.success && !response.invalidMobileNumber && response.locked) {
                this.helperService.notifyError(`Locked, your account has been locked. Please contact support.`, 300, 3000);
              }
              return forgotPasscodeVerify.loadForgotPasscodeVerifySuccess({
                response
              });
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(forgotPasscodeVerify.loadForgotPasscodeVerifyFailure(error));
            })
          )
      )
    )
  );

  verifyOTP$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasscodeVerify.verifyOTP),
      switchMap(action =>
        this.networkCallService
          .post<IVerifyOTPRequest, IVerifyOTPResponse>('Authentication/businessForgotPasscodeVerify', action.request)
          .pipe(
            map(response => {
              if (response.success && !response.invalidMobileNumber && !response.locked) {
                // store token information into session storage to be accessed on confirmation of new passcode
                sessionStorage.setItem('temp_' + SessionStorageIds.USER_MOBILE, action.request.mobileNumber);
                if(response.accessToken) sessionStorage.setItem('temp_' + SessionStorageIds.TOKEN, response.accessToken);
                if(response.refreshToken) sessionStorage.setItem('temp_' + SessionStorageIds.REFRESH_TOKEN, response.refreshToken);
                //Load business user roles before anything else
                const userRolesReq: IBusinessUserRolesRequest = {
                        businessId: null,
                        token: response.accessToken,
                        uniqueDeviceId: EMPTY_GUID
                      };
                this.store.dispatch(actions.loadBusinessUserRoles({ request: userRolesReq }));
                this.router.navigateByUrl(RouteURL.AUTH_FORGOT_PASSCODE);
              } else if (!response.success && !response.invalidMobileNumber && !response.locked) {
                this.helperService.notifyError(`Please check you details and try again.`, 250, 3000);
              } else if (!response.success && !response.invalidMobileNumber && response.locked) {
                this.helperService.notifyError(`Locked! Your account has been locked. Please contact support.`, 300, 3000);
              }
              return forgotPasscodeVerify.verifyOTPSuccess({
                response
              });
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(forgotPasscodeVerify.verifyOTPFailure(error));
            })
          )
      )
    )
  );
}
